define('shared/util/dom/form/enable',[ './getFields' ], function ( getFields ) {
    var KEY_DATA_PREV_STATE = 'disabled.previous';

    function setEnable( $el ) {
        if ( !$el.data(KEY_DATA_PREV_STATE) ) {
            $el.removeAttr( 'disabled');
        }

        $el.removeData(KEY_DATA_PREV_STATE);
    }

    return function disable( $form ) {
        return getFields($form)
            .then(function(emittable){

                emittable.$btn.each(function(i, el){
                    var $el = $(el);
                    setEnable($el)
                });
                emittable.on('add', function($btn){
                    setEnable($btn);
                });

            });
    }
});
